import "./App.css";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import Home from "./Pages/Home";
import Features from "./Pages/Features";
import logo from "./assets/PesoPulse.png";
import About from "./Pages/About";
import Population from "./Pages/Population";
import Footer from "./Pages/Footer";



function App() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  return (
    <div className="App">
      <nav className="navbar navbar-expand-lg navbar-light bg-light py-1 fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand d-flex align-items-center" href="#scrollspyhome">
            <img src={logo} width={55} height={55} alt="Logo" />
            <p className="mb-0 fw-semibold">esoPulse</p>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded={!isNavCollapsed ? true : false}
            aria-label="Toggle navigation"
            onClick={handleNavCollapse}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item border-end">
                <a className="nav-link" href="#scrollspyfeature" onClick={handleNavCollapse}>Features</a>
              </li>
              <li className="nav-item border-end">
                <a className="nav-link" href="#scrollspypopulation" onClick={handleNavCollapse}>Users</a>
              </li>
              <li className="nav-item border-end">
                <a className="nav-link" href="#scrollspyabout" onClick={handleNavCollapse}>About</a>
              </li>
              <li className="nav-item border-end">
                <a className="nav-link" href="https://pesopulse.com/" onClick={handleNavCollapse}>Login</a>
              </li>
              <li className="nav-item ">
                <a className="nav-link" href="https://pesopulse.com/register" onClick={handleNavCollapse}>Register</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div
        data-bs-spy="scroll"
        data-bs-target="#navbarNav"
        data-bs-root-margin="0px 0px -40%"
        data-bs-offset="0"
        className="scrollspy-example bg-body-tertiary"
        tabIndex="0"
      >
        <Home />
        <Features />
        <Population />
        <About />
        <Footer />
      </div>
    </div>
  );
}

export default App;
